// packages/shared/api-client/endpoints/tenants.js
// Tenant/System settings API endpoints

import { baseApi } from "../baseApi";

/**
 * Tenant API endpoints
 * Provides tenant information and system settings management
 */
const tenantApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get public tenant information (unauthenticated)
    getPublicTenantInfo: builder.query({
      query: () => '/api/tenants/public',
      providesTags: ['PublicTenant'],
    }),

    // Get current tenant information
    getCurrentTenant: builder.query({
      query: () => '/api/tenants/current',
      providesTags: ['Tenant'],
    }),

    // Admin: Update tenant information
    updateTenantInfo: builder.mutation({
      query: (tenantData) => ({
        url: '/api/tenants/current',
        method: 'PUT',
        body: tenantData, // { name?, logoUrl?, contactEmail?, contactPhone?, address? }
      }),
      invalidatesTags: ['Tenant'],
    }),

    // Get tenant feature toggles
    getFeatureToggles: builder.query({
      query: () => '/api/tenants/features',
      providesTags: ['TenantFeatures'],
    }),

    // Admin: Update tenant feature toggles
    updateFeatureToggles: builder.mutation({
      query: (features) => ({
        url: '/api/tenants/features',
        method: 'PUT',
        body: features, // { newsFeed?, events?, grievances?, etc. }
      }),
      invalidatesTags: ['TenantFeatures', 'Tenant'],
    }),

    // Admin: Get all tenant settings
    getAllTenantSettings: builder.query({
      query: () => '/api/tenants/settings',
      providesTags: ['TenantSettings'],
    }),

    // Admin: Update tenant settings
    updateTenantSettings: builder.mutation({
      query: (settings) => ({
        url: '/api/tenants/settings',
        method: 'PUT',
        body: settings, // { any custom settings }
      }),
      invalidatesTags: ['TenantSettings', 'Tenant'],
    }),

  }),
});

// Export hooks for usage in components
export const useGetPublicTenantInfoQuery = tenantApi.useGetPublicTenantInfoQuery;
export const useGetCurrentTenantQuery = tenantApi.useGetCurrentTenantQuery;
export const useUpdateTenantInfoMutation = tenantApi.useUpdateTenantInfoMutation;
export const useGetFeatureTogglesQuery = tenantApi.useGetFeatureTogglesQuery;
export const useUpdateFeatureTogglesMutation = tenantApi.useUpdateFeatureTogglesMutation;
export const useGetAllTenantSettingsQuery = tenantApi.useGetAllTenantSettingsQuery;
export const useUpdateTenantSettingsMutation = tenantApi.useUpdateTenantSettingsMutation;
